import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

import DataCollectTable from "@com/table/DataCollectTable.vue";
import { ref, watch } from "vue";
import { OP_KEY, COLUMN_TYPE, OPERATIONS } from "@com/table/tableOperations";
import { Search } from "@element-plus/icons-vue";
import $ from "@util/base";
import api from "@api/productChoose";
import productApi from "@/api/productChoose";
export default {
  __name: 'ProductTable',
  props: {
    type: String,
    typeKey: String,
    codeList: Array,
    isRadio: {
      type: Boolean,
      default: false
    } // 是否是单选

  },

  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    watch(() => props.typeKey, val => {
      if (props.type === 'add') {
        if (props.codeList) {
          data.value = props.codeList;
          total.value = data.value.length;
        } else {
          getData();
        }
      } // else {
      //   // data.value = props.codeList;
      //   data.value =data.value.concat(props.codeList);
      // }

    });
    watch(() => props.codeList, val => {
      if (props.type === 'show' && $.isNotEmpty(val)) {
        if (props.codeList) {
          data.value = data.value.concat(props.codeList); // 使用 map 和 Set 去重

          let uniqueList = Array.from(new Set(data.value.map(item => item.code))).map(code => {
            return data.value.find(item => item.code === code);
          });
          data.value = uniqueList;
          total.value = data.value.length;
        } else {
          getData();
        }
      }
    }); // const emit = defineEmits(['select'])

    const name = ref("");
    const total = ref(0);
    const data = ref([]);
    const config = ref({
      showSelection: props.type === 'add' ? true : false,
      showIndex: true,
      column: [{
        label: "产品图片",
        prop: "mainPic",
        type: COLUMN_TYPE.picture,
        width: 100
      }, {
        label: "产品名称",
        prop: "name"
      }, {
        label: "产品编号",
        prop: "code",
        width: 100
      }, {
        label: "产品分类",
        prop: "category",
        width: 100
      }, {
        label: "产品sku",
        prop: "childName"
      }]
    });
    let params = ref({
      name: null,
      page: null,
      size: null
    });

    function pageChange(key, val) {
      params.value[key] = val;
      getData();
    }

    if ($.isNotEmpty(props.typeKey)) {
      getData();
    }

    function getData() {
      let query = params.value; // api.chooseList(
      //   props.typeKey,
      //   {
      //     codeList: props.codeList,
      //     name: query.name,
      //     page: query.page,
      //     size: query.szie,
      //   },
      //   (val) => {
      //     total.value = val.total;
      //     data.value = val.itemList;
      //   }
      // );

      productApi.chooseList(props.typeKey, {
        name: query.name,
        page: query.page,
        size: query.size
      }, val => {
        if (props.typeKey === 'coupon') {
          data.value = val.list.map(item => {
            return {
              mainPic: '',
              name: item.name,
              code: item.couponCode,
              category: '',
              childName: item.couponDesc
            };
          });
        } else {
          data.value = val.itemList;
        }

        total.value = val.total;
      });
    }

    const tableRef = ref(null);

    function getSelection() {
      let data = tableRef.value.getSelectData();
      data = data.map(item => {
        // return item.code
        return item;
      });
      return data;
    }

    function getSelectData() {
      let data = tableRef.value.getSelectData();
      return data;
    }

    function clearSelection() {
      tableRef.value.clearSelection();
    }

    function empty() {
      total.value = 0;
      data.value = [];
    }

    __expose({
      getSelection,
      getSelectData,
      empty,
      clearSelection
    });

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        inline: true,
        class: "base_search_form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(params).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(params).name = $event),
            "onKeyup[native]": getData,
            onChange: getData,
            placeholder: "名称",
            clearable: "",
            "suffix-icon": _unref(Search)
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(DataCollectTable, {
        ref_key: "tableRef",
        ref: tableRef,
        data: data.value,
        config: config.value,
        total: total.value,
        isRoute: false,
        isRadio: __props.isRadio,
        onPageChange: pageChange
      }, null, 8, ["data", "config", "total", "isRadio"])]);
    };
  }

};